// boxy z podsumowaniem
// @ts-nocheck

import React from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';

import { useGetDashboardSummary } from 'api';
import { useSelector } from 'store';

import styles from 'theme/pages/Dashboard/Dashboard.module.scss';

/** Tylko główny użytkownik klienta (i admin) — zwykły ROLE_USER nie widzi licznika płatności w podsumowaniu */
const canSeePaymentsInSummary = (role?: string) =>
  role === 'ROLE_USER_MAIN' || role === 'ROLE_ADMIN';

const Summary = () => {
  const profile = useSelector((state) => state.auth.profile);
  const showPaymentsBox = canSeePaymentsInSummary(profile?.role);

  // pobranie danych z API
  const { data: dashboardSummaryData } = useGetDashboardSummary();

  return (
    <div 
      className={classnames(styles.summary, 'StylePath-Pages-Dashboard-Components-Summary')}
      style={{ paddingTop: '20px' }}>
      {showPaymentsBox && (
      <div className={styles.box}>
        <Trans>Przedawnione płatności</Trans>
        <span className={classnames(styles.value, styles.red)}>
          {dashboardSummaryData?.payments_expired?.count}
        </span>
      </div>
      )}
      {dashboardSummaryData?.orders_in_progress?.amount_formatted && (
        <div className={styles.box}>
          <Trans>Wartość sprzedaży</Trans>
          <span className={styles.value}>
            {dashboardSummaryData?.orders_in_progress?.amount_formatted}{' '}
            {dashboardSummaryData?.orders_in_progress?.currency}
          </span>
        </div>
      )}
      {dashboardSummaryData?.orders_hold?.count !== undefined && (
        <div className={styles.box}>
          <Trans>Wstrzymane dostawy</Trans>
          <span className={styles.value}>
            {dashboardSummaryData?.orders_hold?.count}
          </span>
        </div>
      )}
      {dashboardSummaryData?.orders_in_progress?.count !== undefined && (
        <div className={styles.box}>
          <Trans>Zamówienia</Trans>
          <span className={styles.value}>
            {dashboardSummaryData?.orders_in_progress?.count}
          </span>
        </div>
      )}
    </div>
  );
};

export default Summary;

